import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_29: FaireProductEntity = {
  token: "catalog_prod_prod-29",
  type: "product",
  name: "Wall Decor",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 105.89,
  msrpDollars: 264.73,
  sku: "PA0029",
  caseSize: 12,
  material: "Metal",
  collectionToken: "col_pattern-play",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 165,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_games-puzzles"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
